import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useCurrentUser, useAppAbility } from '@gsa/afp-shared-ui-utils';
import { Icon } from '@gsa/afp-component-library';
import { CommentPropType } from '../../../utilities/types';
import { ROLES_ENGINEER } from '../../../utilities/types/role-types';
import { OPERATIONS, SUBJECTS } from '../../../utilities/constants';
import DeleteCommentItem from './delete-comment-item';

const Comment = ({ comment, deleteStandardsComment, role = null }) => {
  const ability = useAppAbility();
  const { currentUser } = useCurrentUser();
  const isAdmin = ability.can(OPERATIONS.Manage, SUBJECTS.All);
  const isEngineer = ability.can(OPERATIONS.Manage, SUBJECTS.FVSComments);
  const isOwnComment = comment?.createdByUser === currentUser?.id;

  const getAuthor = () => {
    const fullName = comment?.createdByUserInfo?.fullName;
    const authorType = comment?.authorType;

    if (isOwnComment) {
      return fullName;
    }
    if ((isEngineer || isAdmin) && fullName) {
      return fullName;
    }
    if (authorType === 'VehicleSupplier') {
      return 'Vehicle Supplier';
    }
    if (authorType === ROLES_ENGINEER) {
      return 'GSA Engineer';
    }
    return 'Public user';
  };

  const author = getAuthor();

  return (
    <>
      <div className="grid-row">
        <div className="grid-col-10">
          <div className="display-flex flex-justify">
            <div className="display-flex flex-align-center">
              <Icon
                iconName="account_circle"
                className="usa-icon--size-3 margin-right-1"
              />
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
              <span className="text-bold" tabIndex="0">
                {author}
              </span>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
              <span className="margin-x-4" tabIndex="0">
                {moment(comment?.createdAt).format('l')} &bull;{' '}
                {moment(comment?.createdAt).format('h:mm a')}
              </span>
            </div>
            <DeleteCommentItem
              comment={comment}
              allowChanges={isOwnComment}
              currentUsrId={currentUser.id}
              deleteStandardsComment={deleteStandardsComment}
              deletingComment={false}
              submissionStatus={{
                action: 'delete',
                status: 'success',
                message: '',
              }}
            />
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <p data-testid="comment-text" tabIndex="0">
        {comment?.comment}
      </p>
    </>
  );
};

Comment.propTypes = {
  role: PropTypes.string,
  comment: PropTypes.shape(CommentPropType).isRequired,
  deleteStandardsComment: PropTypes.func.isRequired,
};

export default Comment;
